import { render, staticRenderFns } from "./agregarProducto.vue?vue&type=template&id=0883fde6&scoped=true"
import script from "./agregarProducto.vue?vue&type=script&lang=js"
export * from "./agregarProducto.vue?vue&type=script&lang=js"
import style0 from "./agregarProducto.vue?vue&type=style&index=0&id=0883fde6&prod&scoped=true&lang=css"
import style1 from "./agregarProducto.vue?vue&type=style&index=1&id=0883fde6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883fde6",
  null
  
)

export default component.exports